module.exports = __webpack_public_path__ + "img/withdraw.24e01213.svg";